<script>
    import { onMount } from 'svelte';
    import { db, auth, user } from './stores.js';
    import SignIn from './components/SignIn.svelte';
    let userSocial;
    let status;
    let submitted;
    let description;
    let link;
    let timer;

    console.log('$user: ', $user);

    onMount(async () => {
        if ($user){
            loadInfo($user.uid);
        }
    });

	$auth.onAuthStateChanged(function(userAuthState) {
		if(userAuthState){
            loadInfo(userAuthState.uid);
		} else {
			// console.log('onAuthStateChanged no user');
			// $user = null;
		};
	});

    function loadInfo(uid) {
        // get logged in social account
        $db.collection("users").doc(uid).get().then((doc) => {
            if (doc.exists) {
                console.log("User data: ", doc.data());
                userSocial = {...doc.data()}
                console.log("userSocial: ", userSocial);

            } else {
                console.error("No such document");
            }
        }).catch((error) => {
            console.log("Error getting document: ", error);
        });
        // check for already submitted show and tell
        $db.collection("showandtell").doc($user.uid).get().then((doc) => {
            if (doc.exists) {
                console.log("Show and tell submission: ", doc.data());
                // description = doc.data().description;
                // link = doc.data().link ? doc.data().link : undefined;
                // status = doc.data().status;
                submitted = true;
                $db.collection("showandtell").doc($user.uid)
                    .onSnapshot((doc) => {
                        console.log("Current data: ", doc.data());
                        if (doc.data()){
                            description = doc.data().description;
                            link = doc.data().link ? doc.data().link : undefined;
                            status = doc.data().status;
                            if (status.approved && timer){
                                timer.restart(status.data);
                            }
                        }
                    });

            } else {
                console.log("no document");
                submitted = false;
            }
        }).catch((error) => {
            console.log("Error getting document: ", error);
        });
    };

    function handleSubmit(e) {
        console.log("handle submit!");
        if (description){
            $db.collection("showandtell").doc($user.uid).set({
                ...userSocial,
                description,
                link: link ? link : null,
                status: {approved: false, data:null} 
            }).then(() => {
                console.log("show and tell successfully submited");
                submitted = true;
                $db.collection("showandtell").doc($user.uid)
                    .onSnapshot((doc) => {
                        console.log("Current data: ", doc.data());
                        if (doc.data()){
                            description = doc.data().description;
                            link = doc.data().link ? doc.data().link : undefined;
                            status = doc.data().status;
                        }
                    });
            }).catch((error) => {
                    console.error("Error submitting show and tell: ", error);
                    submitted = false;
                })
        }

    }

    function handleCancel(){
        console.log("handle cancel");
        $db.collection("showandtell").doc($user.uid).delete().then(() => {
            console.log("Document successfully deleted!");
            submitted = false;
            description = "";
            link = "";
            status = {approved:false, data:null}

        }).catch((error) => {
            console.error("Error removing document: ", error);
            submitted = true;
        });
    }

</script>

<main>
	{#if $user}
        <section>
            <h2>Got something to share? Tell us about it!</h2>
            <h3>
                Fill out the form and we'll get it scheduled.
                <br/>Check back for updates to the status section.
            </h3>
            <h4>You get 5 minutes and please wear headphones.</h4>
            <textarea bind:value={description} placeholder="Enter a description" disabled={submitted}></textarea>
            <input bind:value={link} placeholder="Got a link?" disabled={submitted}>
            <br/> status: 
            {#if status }
                {#if status.data}
                    {#if status.approved}
                        Scheduled to go live: <dwane-timer bind:this={timer} timer-deadline={status.data} countdown-start="3600000"></dwane-timer>
                        <br/>We will do a test run before going live.
                    {:else}
                        {status.data}
                    {/if}
                {/if}
            {/if}
            <br/><br/><button on:click="{handleSubmit}" disabled={submitted || !description} >submit</button>
            {#if submitted}
                <button on:click="{handleCancel}">cancel</button>
            {/if}
        </section>
	{:else}
        <div>
            Please login before signing up for Show and Tell.
    		<SignIn />
        </div>
	{/if}
</main>

<style>
    main {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    section {
        max-width: 500px;
    }

    textarea {
        width: 100%;
        height: 200px;
    }

    input {
        width: 100%;
    }

    button {
        cursor: pointer;
    }
    button:disabled {
        cursor: not-allowed;
    }

    dwane-timer {
        display: inline-block;
    }
</style>
